import _isNil from 'lodash/isNil';
import _isNumber from 'lodash/isNumber';
import _isEmpty from 'lodash/isEmpty';

export type Key = string | null;
export type Value = string | string[] | number | number[] | null;

export default class ParameterKeyValue {
  public readonly key: Key;
  public readonly value: Value;

  constructor(key: Key = null, value: Value = null) {
    this.key = key;
    this.value = value;
  }

  /**
   * flag determining if this parameter has value and should be sent in the api request
   *
   * @readonly
   * @memberof ParameterKeyValue
   */
  get hasValue(): boolean {
    const hasNilKeyOrValue = _isNil(this.key) || _isNil(this.value);
    const hasEmptyValue = _isNumber(this.value)
      ? _isNil(this.value)
      : _isEmpty(this.value);

    return !hasNilKeyOrValue && !hasEmptyValue;
  }
}
